<div class="personal-data-container component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'personal-data.form-details.installer-company-title' | translate"
      [tooltip]="'tooltips.personal-data.installer-company' | translate"
      [showTooltip]="infoBubblesData?.showInstallerCompanyHeaderInfo"></app-section-header>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <form
      *ngIf="systemCompanyInstallerFG"
      [formGroup]="systemCompanyInstallerFG"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 sub-section-heading">
        {{ 'personal-data.form-details.system-installer' | translate }}
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="system_taxId">{{ 'basic-profile.fields.tax_id' | translate }}</label>
          <input
            class="ui-input pInputText"
            id="system_taxId"
            pInputText
            formControlName="system_taxId"
            type="text"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label
            class="ui-g-5 field-label text-right-align"
            for="system_title"
            [ngClass]="shouldMarkFirstAndLastNameAsMandatory ? 'required' : ''">
            {{ 'personal-data.form-details.fields.title' | translate }}
          </label>
          <p-dropdown [options]="titles" formControlName="system_title" id="system_title" placeholder="-Select-" [readonly]="isReadOnly">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="system_company">
            {{ 'basic-profile.fields.company' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_company"
            pInputText
            formControlName="system_company"
            type="text"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label
            class="ui-g-5 field-label text-right-align"
            [ngClass]="shouldMarkFirstAndLastNameAsMandatory ? 'required' : ''"
            for="system_name">
            {{ 'basic-profile.fields.name' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_name"
            pInputText
            formControlName="system_name"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="system_street">
            {{ 'personal-data.form-details.fields.street' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_street"
            pInputText
            formControlName="system_street"
            type="text"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label
            class="ui-g-5 field-label text-right-align"
            [ngClass]="shouldMarkFirstAndLastNameAsMandatory ? 'required' : ''"
            for="system_firstName">
            {{ 'personal-data.form-details.fields.first-name' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_firstName"
            pInputText
            formControlName="system_firstName"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="system_streetNumber">
            {{ 'personal-data.form-details.fields.street-number' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_streetNumber"
            pInputText
            formControlName="system_streetNumber"
            type="text"
            [maxlength]="shouldRestrictStreetNumberTo5Chars ? 5 : 10"
            [readonly]="isReadOnly" />
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <label class="ui-g-5 field-label text-right-align" for="system_telephone">
            {{ 'personal-data.form-details.fields.telephone' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_telephone"
            pInputText
            formControlName="system_telephone"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="system_postCode">
            {{ 'personal-data.form-details.fields.post-code' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_postCode"
            pInputText
            formControlName="system_postCode"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align" for="system_city">
            {{ 'personal-data.form-details.fields.city' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_city"
            pInputText
            formControlName="system_city"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="system_telephoneCentral">
            {{ 'basic-profile.fields.telephone_central' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            id="system_telephoneCentral"
            pInputText
            formControlName="system_telephoneCentral"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </div>
    </form>
    <!--		<form *ngIf="installerCompanyFG" [formGroup]="installerCompanyFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 sub-section-heading">-->
    <!--				{{'personal-data.form-details.installer-company' | translate}}-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align"-->
    <!--						   for="company_taxId">{{'personal-data.form-details.fields.tax-id' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_taxId" pInputText-->
    <!--						   formControlName="company_taxId" type="text">-->
    <!--				</div>-->
    <!--	-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">-->
    <!--					<label class="ui-g-5 field-label text-right-align"-->
    <!--						   for="company_title">{{'personal-data.form-details.fields.title' | translate}}</label>-->
    <!--					<p-dropdown [options]="titles"-->
    <!--					            formControlName="company_title"-->
    <!--					            id="company_title"-->
    <!--					            placeholder="-Select-">-->
    <!--						<ng-template let-item pTemplate="selectedItem">-->
    <!--							<span class="drop-item-label">{{'lookup.' + titleKey + '.options.' + item.value + '.name' | translate}}</span>-->
    <!--						</ng-template>-->
    <!--						<ng-template let-option pTemplate="item">-->
    <!--							<div class="drop-item">-->
    <!--								<span class="drop-item-label">{{'lookup.' + titleKey + '.options.' + option.value + '.name' | translate}}</span>-->
    <!--							</div>-->
    <!--						</ng-template>-->
    <!--					</p-dropdown>-->
    <!--				</div>-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align required"-->
    <!--						   for="company">{{'basic-profile.fields.company' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company" pInputText-->
    <!--						   formControlName="company" type="text">-->
    <!--				</div>-->
    <!--	-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">-->
    <!--					<label class="ui-g-5 field-label text-right-align"-->
    <!--						   for="company_name">{{'basic-profile.fields.name' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_name"-->
    <!--						   pInputText formControlName="company_name"-->
    <!--						   type="text">-->
    <!--				</div>-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align required"-->
    <!--						   for="company_street">{{'personal-data.form-details.fields.street' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_street" pInputText-->
    <!--						   formControlName="company_street" type="text">-->
    <!--				</div>-->
    <!--	-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">-->
    <!--					<label class="ui-g-5 field-label text-right-align"-->
    <!--						   for="company_firstName">{{'personal-data.form-details.fields.first-name' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_firstName"-->
    <!--						   pInputText formControlName="company_firstName"-->
    <!--						   type="text">-->
    <!--				</div>-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align required"-->
    <!--						   for="company_streetNumber">{{'personal-data.form-details.fields.street-number' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_streetNumber" pInputText-->
    <!--						   formControlName="company_streetNumber" type="text">-->
    <!--				</div>-->
    <!--	-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">-->
    <!--					<label class="ui-g-5 field-label text-right-align"-->
    <!--						   for="company_telephone">{{'personal-data.form-details.fields.telephone' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_telephone"-->
    <!--						   pInputText formControlName="company_telephone"-->
    <!--						   type="text">-->
    <!--				</div>-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align required"-->
    <!--						   for="company_postCode">{{'personal-data.form-details.fields.post-code' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_postCode" pInputText-->
    <!--						   formControlName="company_postCode" type="text">-->
    <!--				</div>-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align"-->
    <!--						   for="company_city">{{'personal-data.form-details.fields.city' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_city" pInputText-->
    <!--						   formControlName="company_city" type="text">-->
    <!--				</div>-->
    <!--			</div>-->
    <!--			<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">-->
    <!--				<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">-->
    <!--					<label class="ui-g-5 field-label text-right-align required"-->
    <!--						   for="company_telephoneCentral">{{'basic-profile.fields.telephone_central' | translate}}</label>-->
    <!--					<input class="ui-input pInputText" id="company_telephoneCentral" pInputText-->
    <!--						   formControlName="company_telephoneCentral" type="text">-->
    <!--				</div>-->
    <!--			</div>-->
    <!--		</form>-->
  </div>
</div>
